import { useContext } from "react";
import { AppContext } from "../App";
import AboutUsLanding from "../views/AboutUsLanding";
import TeamLanding from "../views/TeamLanding";

export default function AboutUs() {
  const appContext = useContext(AppContext);

  if (
    (!appContext.navSubItem || appContext.navSubItem === "overview") &&
    !appContext.navExtraItem &&
    !appContext.navMoreItem
  ) {
    return <AboutUsLanding />;
  }

  if (
    appContext.navSubItem === "team" &&
    !appContext.navExtraItem &&
    !appContext.navMoreItem
  ) {
    return <TeamLanding />;
  }

  return <AboutUsLanding />;
}

